module.exports = "/fonts/element-icons.woff?313f7dacf2076822059d2dca26dedfc6";